// ----
// JS for Toolbar
// ----

var SCM = SCM || {};

(function (ns, $, $document, undefined) {
    // ----
    // private variables and functions
    // ----
    var $toolbar,
        $viewDrop,
        $shareDrop,
        $toolsDrop,
        _shareMousedownGuard,
        _shareClickGuard;

    // C0004 is the standard OneTrust IAB targeting/advertising category — the same ID that
    // appears in the optanon-category-C0004 class on ShareThis script tags. A non-standard
    // tenant ID would also require changing that class, which would break OtAutoBlock.js.
    var TARGETING_COOKIE_CATEGORY = 'C0004';

    function isTargetingCookieAccepted() {
        return typeof OnetrustActiveGroups === 'string' &&
               OnetrustActiveGroups.split(',').indexOf(TARGETING_COOKIE_CATEGORY) !== -1;
    }

    function hasCookieConsent() {
        // Sites without OneTrust/CookiePro never set OnetrustActiveGroups —
        // ShareThis loads unconditionally on those sites, so treat undefined as consented.
        return typeof OnetrustActiveGroups === 'undefined' ? true : isTargetingCookieAccepted();
    }

    function closeShareDropdown() {
        // Close dropdown via direct DOM manipulation — triggering .drop-trigger click would
        // toggle the dropdown (risk of re-opening if timing is off). No-op on CMS post pages
        // where #ShareDrop is a flat list with no dropdown state.
        $shareDrop.removeClass('open');
        $shareDrop.closest('.item-share').find('.drop-trigger').attr('aria-expanded', false);
        $shareDrop.closest('.item-share').find('.js-toolbar-arrow-icon')
            .removeClass('icon-general_arrow-up').addClass('icon-general_arrow-down');
    }

    function handleShareBlockedByCookies(e) {
        if (hasCookieConsent()) {
            return;
        }
        e.preventDefault();
        // stopImmediatePropagation prevents any other handlers on .js-share-link from firing
        // (e.g., AddThis/ShareThis listeners attached to the same element). preventDefault alone
        // is insufficient because ShareThis uses its own listeners that ignore defaultPrevented.
        e.stopImmediatePropagation();

        closeShareDropdown();

        // Note: after accepting C0004 via the OneTrust panel, OnetrustActiveGroups updates
        // immediately but ShareThis re-initializes asynchronously — a very fast click after
        // accepting could still be a silent no-op. Pre-existing async injection constraint.
        SCM.Modals.showModal($('#cookieShareModal'));
    }

    function showProperToolbarOptions() {
        hideActiveTabLinkFromViewsList();
        showMenuItemIfHasVisibleItemsInside();
    }

    function showMenuItemIfHasVisibleItemsInside() {
        var $ddTriggers = $('.item-with-dropdown');
        $ddTriggers.each(function () {
            var $this = $(this);
            var isDownloadItem = $this.hasClass('item-pdf') || $this.hasClass('item-epub') || $this.hasClass('item-mobi');
            var visibleItemsExist = $this.find('ul li:not(.hide), .js-single-pdf-link').length > 0;
            if (visibleItemsExist || isDownloadItem) {
                $this.removeClass('hide');
            }
        });
    }

    function hideActiveTabLinkFromViewsList() {
        $('.tab-item').parent('li').removeClass('hide');

        if ($('.tabs-content').length) {
            var activeTab = '';

            $('.tabs-content > .content').each(function () {
                var $this = $(this);
                if ($this.hasClass('active')) {
                    activeTab = $this.attr('id');
                }
            });
            $('#ViewsDrop li.has-content').removeClass('hide');
            $('#ViewsDrop').find('[data-tab="#' + activeTab + '"]').closest('li').addClass('hide');
        }
    }



    // ----
    // public methods and properties accessible by SCM.IssuePage.[method_name]
    // ----
    ns.closeDropDownIfChildItemClicked = function () {
        $('#Toolbar .f-dropdown > li').on('click', function () {
            $(this).closest('.toolbar-item').trigger('click');
        });
    };

    ns.removeTabLinkIfTabIsEmpty = function (cssSelector) {
        $(cssSelector).find('.tab-trigger').each(function () {
            var $this = $(this),
                tabName = $this.attr('data-tab');

            // find('*') grabs all descendent HTML elements so we can count.
            // if there are less than 20 Elements, the tab might be empty. Do a further check to validate
            // that the widget didn't output any content. Remove toolbar link if widget didn't output any content.
            // We don't want to do a costly regex replace if the widget outputs a large chunk of HTML.
            if (tabName !== '#ContentTab' && $(tabName).find('*').length < 20) {
                var html = $(tabName).html();
                var regex = /(<([^>]+)>)/ig;
                var result = html !== undefined ? $.trim(html.replace(regex, '')) : 1;

                if (result.length === 0) {
                    $this.parent('li').remove();
                }
            }
        });
    };

    ns.showTabIfDropdownHasItems = function () {
        var dropdowns = [$pdfDrop, $shareDrop, $toolsDrop];

        for (var i = 0; i < dropdowns.length; i++) {
            var currentDd = dropdowns[i];
            if (currentDd && currentDd.children('li').length > 0) {
                currentDd.parent().removeClass('hide');
            }
        }
        if ($viewDrop.children('li:not(.hide)').length >= 1) {
            $viewDrop.parent().removeClass('hide');
        }
    };

    ns.toggleTabContent = function () {
        $('.tab-trigger').on('click', function (e) {
            e.preventDefault();

            var $this = $(this),
                tabId = $this.attr('data-tab'),
                $tab = $(tabId);

            $tab.siblings().removeClass('active');
            $tab.addClass('active');

            if (tabId === '#FigureTab') {
                $document.trigger('scroll'); // Trigger scroll so lazy load can load images.
            }
            showProperToolbarOptions();
        });
    };

    ns.styleToolbarStates = function () {
        $toolbar.on('click', '.toolbar-item', function () {
            var $this = $(this);
            $this.addClass('clicked');
            $this.siblings().removeClass('clicked');
        });

        $document.on('click', function () {
            $('.toolbar-item').each(function () {
                var $this = $(this);
                if (!$this.find('ul').hasClass('open')) {
                    $this.removeClass('clicked');
                }
            });
        });
    };
    ns.mobileToolbarAccordian = function () {
        $('.js-toolbar-trigger').on('click', function (e) {
            var $currMenu = $(this).next('.js-toolbar');
            var $currToolbarTriggerArrowIcon = $(this).find('.js-toolbar-trigger-arrow-icon');
            var arrowDown = 'icon-general_arrow-down';
            var arrowUp = 'icon-general_arrow-up';
            $currMenu.toggleClass('open');
            e.stopPropagation();

            if ($currMenu.hasClass('open')) {
                $currToolbarTriggerArrowIcon.removeClass(arrowDown).addClass(arrowUp);
            }
            else {
                $currToolbarTriggerArrowIcon.removeClass(arrowUp).addClass(arrowDown);
                $('.toolbar-search').removeClass('expanded');
                $('.f-dropdown').removeClass('open');
            }

            $(document.body).on('click', function () {
                $currMenu.removeClass('open');
                if ($currToolbarTriggerArrowIcon.hasClass(arrowUp)) {
                    $currToolbarTriggerArrowIcon.removeClass(arrowUp).addClass(arrowDown);
                }
            });
        });
    };
    ns.toolbarDropdowns = function () {
        $('.js-toolbar-dropdown').on('click', function (e) {
            var $currMenu = $(this).next('.f-dropdown');
            var $currToolbarArrowIcon = $(this).find('.js-toolbar-arrow-icon');
            var arrowDown = 'icon-general_arrow-down';
            var arrowUp = 'icon-general_arrow-up';
            e.stopPropagation();

            $('.f-dropdown').not($currMenu).removeClass('open');
            $('.js-toolbar-arrow-icon').not($currToolbarArrowIcon).removeClass(arrowUp).addClass(arrowDown);
            $('.toolbar-search').removeClass('expanded');

            if ($currMenu.hasClass('open')) {
                $(this).attr("aria-expanded", false);
                $currMenu.removeClass('open');
                $currToolbarArrowIcon.removeClass(arrowUp).addClass(arrowDown);
            }
            else {
                $(this).attr("aria-expanded", true);
                $currMenu.addClass('open');
                SCM.DropdownContainment.keepInViewport($currMenu);
                $currToolbarArrowIcon.removeClass(arrowDown).addClass(arrowUp);
            }

            $(document.body).on('click', function () {
                $currMenu.removeClass('open');
                if ($currToolbarArrowIcon.hasClass(arrowUp)) {
                    $currToolbarArrowIcon.removeClass(arrowUp).addClass(arrowDown);
                }
            });
        });
    };

    ns.stickyToolbar = function () {
        if ($('.page-column--left').length) {
            var $toolbarWrap = $('.toolbar-wrap');
            if ($toolbarWrap.length) {
                var toolbarOriginalTop = $toolbarWrap.offset().top;

                $(window).on('scroll', function () {
                    // Modal scroll-lock sets body position:fixed, collapsing scrollY to 0 and firing a
                    // spurious scroll event; ignore it so the toolbar stays stuck and the page underneath
                    // the modal does not shift.
                    if (document.body.style.position === 'fixed') {
                        return;
                    }
                    var scroll = $(window).scrollTop();
                    if (scroll < toolbarOriginalTop) {
                        $toolbarWrap.removeClass('toolbar-stuck');
                        $('.site-theme-header').find('.navbar-search-container').removeClass('hide');
                    } else {
                        $toolbarWrap.addClass('toolbar-stuck');
                        $('.site-theme-header').find('.navbar-search-container').addClass('hide');
                    }
                });
            }
        }
    };

    function initContentFilter() {
        if ($('#ContentTab .widget-ArticleFulltext').length) {
            configureContentFilters('ArticleFulltext', 'ArticleDataSupplements', 'PeerReview');
        }
        else if ($('#ContentTab .widget-BookSectionsText').length) {
            configureContentFilters('BookSectionsText', 'DataSupplements', 'PeerReview');
        }
        else if ($('#ContentTab .widget-BookToc').length) {
            configureContentFilters('BookToc', 'DataSupplements', 'PeerReview');
        }
    }

    function configureContentFilters(contentWidgetName, dataSupplementsWidgetName, peerReviewWidgetName) {

        initializeFilterMenu(contentWidgetName, dataSupplementsWidgetName, peerReviewWidgetName);

        wireFilterMenuItems(contentWidgetName, dataSupplementsWidgetName, peerReviewWidgetName);
    }

    function initializeFilterMenu(contentWidgetName, dataSupplementsWidgetName, peerReviewWidgetName) {
        var sectionSets = getSectionSets(contentWidgetName, dataSupplementsWidgetName, peerReviewWidgetName);

        if (sectionSets.$figuresTablesSections.length) {
            $viewDrop.find('.js-content-filter[data-content-filter="figures-tables"]')
                .addClass('has-content').removeClass('hide');
        }

        if (sectionSets.$videoSections.length) {
            $viewDrop.find('.js-content-filter[data-content-filter="video"]')
                .addClass('has-content').removeClass('hide');
        }

        if (sectionSets.$audioSections.length) {
            $viewDrop.find('.js-content-filter[data-content-filter="audio"]')
                .addClass('has-content').removeClass('hide');
        }

        var hasFigshareContent = $('figshare-widget').length && $('figshare-widget').children().length;
        if (sectionSets.$supplementaryData.length || sectionSets.$supplementalFigures.length || hasFigshareContent) {
            $viewDrop.find('.js-content-filter[data-content-filter="supplementary-data"]')
                .addClass('has-content').removeClass('hide');
        }

        if (sectionSets.$peerReviewSections.length) {
            $viewDrop.find('.js-content-filter[data-content-filter="peer-review"]')
                .addClass('has-content').removeClass('hide');
        }

        var hasVisibleFilters = $viewDrop.find('.js-content-filter.has-content').length > 0;
        if (hasVisibleFilters) {
            $viewDrop.find('.js-content-filter[data-content-filter="article-content"]')
                .addClass('has-content');
            $viewDrop.closest('.js-item-views').removeClass('hide');
        }
    }

    function wireFilterMenuItems(contentWidgetName, dataSupplementsWidgetName, peerReviewWidgetName) {
        var $downloadAllImages = $('#ContentTab').find('div.downloadImagesppt');
        var $metadataStandalone = $('.article-metadata-standalone-panel');

        $viewDrop.children('.article-content-filter')
            .on('click', function () {
                var sectionSets = getSectionSets(contentWidgetName, dataSupplementsWidgetName, peerReviewWidgetName);
                var $selectedMenuItem = $(this);
                $selectedMenuItem.addClass('hide');
                $selectedMenuItem.siblings('.has-content').removeClass('hide');

                var contentFilter = $selectedMenuItem.attr('data-content-filter');

                var $filteredContent = null;

                if (contentFilter === 'figures-tables') {
                    $filteredContent = sectionSets.$figuresTablesSections.add(sectionSets.$supplementalFigures);
                } else if (contentFilter === 'video') {
                    $filteredContent = sectionSets.$videoSections;
                } else if (contentFilter === 'audio') {
                    $filteredContent = sectionSets.$audioSections;
                } else if (contentFilter === 'supplementary-data') {
                    $filteredContent = sectionSets.$supplementaryData
                        .add(sectionSets.$supplementalFigures)
                        .add(sectionSets.$figshareContent);
                } else if (contentFilter === 'peer-review') {
                    $filteredContent = sectionSets.$peerReviewSections;
                }

                if ($filteredContent && $filteredContent.length) {
                    sectionSets.$contentTopSections.hide();
                    sectionSets.$contentSections.hide();
                    sectionSets.$supplementaryData.hide();
                    sectionSets.$peerReviewSections.hide();
                    revealSections($filteredContent);
                    sectionSets.$commentsSection.hide();
                    sectionSets.$pdfPreviewSections.hide();
                    setDownloadImageLink($filteredContent, $downloadAllImages);
                } else {
                    sectionSets.$contentTopSections.show();
                    sectionSets.$contentSections.show();
                    $metadataStandalone.length > 1
                        ? $metadataStandalone.show() :
                        $metadataStandalone.hide();
                    sectionSets.$supplementaryData.show();
                    sectionSets.$peerReviewSections.show();
                    sectionSets.$pdfPreviewSections.show();
                    sectionSets.$commentsSection.show();
                    $downloadAllImages.hide();
                }

                SCM.SiteJS.restrictedImages();
            });
    }

    function revealSections($sections) {
        if (!$sections || !$sections.each) {
            return;
        }
        $sections.each(function (i, section) {
            revealSection($(section));
        });
    }

    function revealSection($section) {
        if (!$section || $section.length !== 1 || !$section.show) {
            return;
        }

        $section.show();
        var $parent = $section.parent();
        while ($parent && $parent.length && !$parent.is('#ContentTab')) {
            $parent.show();
            $parent = $parent.parent();
        }
    }

    function setDownloadImageLink($contentSections, $downloadAllImages) {
        if ($contentSections.filter('.fig-section:not(:has(a[restricted]))').length) {
            $downloadAllImages.show();
        } else {
            $downloadAllImages.hide();
        }
    }

    function getSectionSets(contentWidgetName, dataSupplementsWidgetName, peerReviewWidgetName) {
        var $contentSections = getContentSections(contentWidgetName);
        var sectionSets = {
            // Exclude the SR-only accessibility span — jQuery's .show() overrides the hidden attribute, making it visible
            $contentTopSections: $('.widget-items[data-widgetname="' + contentWidgetName + '"]')
                .children(':not(#sr-fig-viewer-action)'),
            $contentSections: $contentSections,
            $figuresTablesSections: $contentSections.has('.table-wrap, .fig-section'),
            $supplementalFigures: $contentSections.has('.supplemental-figure'),
            $videoSections: $contentSections.has('.video-section'),
            $audioSections: $contentSections.has('.audio-section'),
            $commentsSection: $('#ContentTab').find('div.comments'),
            $pdfPreviewSections: $('#ContentTab').find('.widget-FirstPagePreview'),
            $supplementaryData: $('.widget-' + dataSupplementsWidgetName + ', .supplementary-material'),
            $figshareContent: $('#articlefulltext_figshare'),
            $peerReviewSections: $('.widget-' + peerReviewWidgetName + ', .js-peer-review')
        };

        return sectionSets;
    }

    function getContentSections(contentWidgetName) {
        var $contentSections = $('.widget-items[data-widgetname="' + contentWidgetName + '"]')
            .find('.js-content-section');

        var $glencoeVideoContentSections = $('.widget-items[data-widgetname="' + contentWidgetName + '"]')
            .find('.fig-section.vid').closest('div.article-section-wrapper');

        if ($glencoeVideoContentSections && $glencoeVideoContentSections.length) {
            return $contentSections.add($glencoeVideoContentSections);
        } else {
            return $contentSections;
        }
    }

    function initCmeQuizToolbar() {

        var $cmeToolbarItem = $('.js-toolbar-item-cme-quiz');
        var $cmeWidgetElem = $('.widget-RieventCmeQuiz');
        var $closeCmeSpan = $('.js-item-cme-quiz.cme-close');
        var $spanItems = $('.js-item-cme-quiz span');
        var $userComment = $('.js-userComments');

        if ($cmeToolbarItem.length) {
            if (!$cmeWidgetElem.length) {
                $cmeToolbarItem.addClass('hide');
                return;
            }

            if (!$closeCmeSpan.hasClass('hide')) {
                $closeCmeSpan.addClass('hide');
            }

            if (!$cmeWidgetElem.hasClass('hide')) {
                $cmeWidgetElem.addClass('hide');
            }

            $('.js-item-cme-quiz').on('click', function () {
                $spanItems.toggleClass('hide');
                $cmeWidgetElem.toggleClass('hide');
                $userComment.toggleClass('hide');
                $('#ContentTab').toggleClass('hide');
            });
        }
    }

    var dropdownsInitialized = false;

    function initializeToolbarFilters() {
        initContentFilter();
        ns.showTabIfDropdownHasItems();
        if (!dropdownsInitialized) {
            dropdownsInitialized = true;
            ns.toolbarDropdowns();
        }
    }

    ns.init = function () {
        // Guard against DOM clobbering: content elements with id="ga" (e.g. graphical abstracts)
        // create window.ga as an HTMLElement, which crashes ShareThis when it calls ga() expecting
        // the Google Analytics function. Replace with a no-op so share button clicks don't throw.
        if (typeof window.ga !== 'undefined' && typeof window.ga !== 'function') {
            window.ga = function () {};
        }

        $toolbar = $('#Toolbar');
        $badgeBar = $('.badge-bar');
        $shareDrop = $('#ShareDrop');

        if (!$toolbar.length && !$badgeBar.length && !$shareDrop.length) {
            return;
        }

        // Cookie consent share-link interception. Covers the toolbar (#ShareDrop inside #Toolbar)
        // and CMS post pages (#ShareDrop rendered standalone outside any toolbar).
        // Listeners are scoped to #ShareDrop rather than document to limit the runtime footprint
        // to the share area — no handler fires on mousedown/click elsewhere on the page.
        //
        // Must use capture phase (third arg = true) so our handlers fire before ShareThis's
        // direct element-level listeners. ShareThis calls window.open() on mousedown (to avoid
        // popup blockers), so a delegated jQuery listener on $shareDrop fires during bubbling
        // and is too late. We intercept both events:
        //   - mousedown capture: blocks ShareThis from opening the popup window
        //   - click capture: shows the cookie consent modal to the user
        //
        // Do not copy this capture-phase pattern to other features — it is only necessary here
        // because ShareThis calls window.open() on mousedown. Standard delegated jQuery listeners
        // are sufficient everywhere else.
        if ($shareDrop.length) {
            _shareMousedownGuard = function (e) {
                var shareLink = $(e.target).closest('.js-share-link')[0];
                if (!shareLink || hasCookieConsent()) {
                    return;
                }
                e.preventDefault();
                // stopImmediatePropagation in capture phase also silences any bubble-phase
                // listeners on .js-share-link (e.g. analytics handlers) for sessions where
                // cookies are rejected. Use ns.removeShareCookieGuard() to unbind if needed.
                e.stopImmediatePropagation();
            };

            _shareClickGuard = function (e) {
                var shareLink = $(e.target).closest('.js-share-link')[0];
                if (!shareLink) {
                    return;
                }
                handleShareBlockedByCookies(e);
            };

            $shareDrop[0].addEventListener('mousedown', _shareMousedownGuard, true);
            $shareDrop[0].addEventListener('click', _shareClickGuard, true);

            // Persistent delegated listener for the "Update Cookie Preferences" button inside
            // the cookie consent modal. Wired once at init to avoid accumulating duplicate
            // handlers on repeated share link clicks while cookies are rejected.
            $(document.body).on('click', '.js-share-cookie-prefs-btn', function () {
                SCM.Modals.closeModal();
                if (typeof OneTrust !== 'undefined' && OneTrust.ToggleInfoDisplay) {
                    try {
                        OneTrust.ToggleInfoDisplay();
                    } catch (e) {
                        // SDK threw unexpectedly — reopen the modal so the user isn't stranded
                        // with no way to dismiss or retry.
                        SCM.Modals.showModal($('#cookieShareModal'));
                    }
                }
            });
        }

        if (!$toolbar.length && !$badgeBar.length) {
            return; // CMS post page — only cookie consent listeners needed above
        }

        $viewDrop = $('#ViewsDrop');
        $toolsDrop = $('#ToolsDrop');
        $pdfDrop = $('#PdfDrop');
        showProperToolbarOptions();
        ns.mobileToolbarAccordian();
        ns.removeTabLinkIfTabIsEmpty($viewDrop);
        ns.styleToolbarStates();
        ns.toggleTabContent();

        initializeToolbarFilters();

        $(document).on('figshare:contentLoaded', function() {
            initializeToolbarFilters();
        });

        initCmeQuizToolbar();
    };

    // Removes the cookie consent capture-phase listeners from #ShareDrop. Call this if a
    // future feature needs to attach its own bubble-phase handler to .js-share-link and
    // must fire even when targeting cookies are rejected.
    ns.removeShareCookieGuard = function () {
        if ($shareDrop && $shareDrop.length && _shareMousedownGuard && _shareClickGuard) {
            $shareDrop[0].removeEventListener('mousedown', _shareMousedownGuard, true);
            $shareDrop[0].removeEventListener('click', _shareClickGuard, true);
        }
    };

})(SCM.Toolbar = SCM.Toolbar || {}, jQuery, $(document));


